var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDfClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10a4 4 0 00-4 4v48a4 4 0 004 4h38a4 4 0 004-4V14a4 4 0 00-4-4h-4v4h4v48H19V14h4v-4h-4zm8 0v8h22v-8h-4v4H31v-4h-4zm26 16v3H37v-3h16zm0 15v-3H37v3h16zm0 9v3H37v-3h16zM23 28l2-2 2 2 4.5-5 2 2-6.5 7-4-4zm2 10l-2 2 4 4 6.5-7-2-2-4.5 5-2-2zm-2 14l2-2 2 2 4.5-5 2 2-6.5 7-4-4z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/DF_Clipboard.4147f5f7.svg";
export { SvgDfClipboard as ReactComponent };